<template>
  <div class="page_setting">
    <div class="page-header">
      <div class="page-header-index-wide">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <router-link :to="{ path: '/' }">首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>设置</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>小程序配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
          <div class="main" >
            <div class="row">
              <h1 class="title">小程序配置</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" :style="{ flexWrap: device === 'mobile' ? 'wrap' : 'nowarp'}">
      <a-menu
        class="p-t-12"
        :style="{
          width: device === 'mobile' ? '100%' : '256px',
          minHeight: device === 'mobile' ? '0' : '80vh'
        }"
        :default-selected-keys="_key" :mode="device === 'mobile' ? 'horizontal' : 'vertical'" @click="handleClick">
        <a-menu-item v-if="can('splash')" key="1">载入页</a-menu-item>
        <a-menu-item v-if="can('advertise')" key="2">广告页</a-menu-item>
        <a-menu-item v-if="can('storelevel')" key="3">门店等级</a-menu-item>
        <a-menu-item v-if="can('storestar')" key="4">门店星级</a-menu-item>

        <!-- <a-menu-item v-if="can('servicefee')" key="5">上门服务费</a-menu-item> -->
        <a-menu-item v-if="can('limitnumber')" key="12">限制购买次数</a-menu-item>

        <!-- <a-menu-item v-if="can('reminderdays')" key="13">铺货库存提醒天数</a-menu-item> -->

        <a-menu-item v-if="can('nearbystore')" key="6">附近门店</a-menu-item>
        <a-menu-item v-if="can('storebg')" key="7">店铺背景图</a-menu-item>

        <a-menu-item v-if="can('setpoints')" key="8">设置积分</a-menu-item>
        <a-menu-item v-if="can('pointsrules')" key="9">积分规则</a-menu-item>

        <a-menu-item v-if="can('cyclingevent')" key="14">骑行活动示例图片</a-menu-item>
        <a-menu-item v-if="can('stackheadImage')" key="16">堆头活动示例图片</a-menu-item>

        <a-menu-item v-if="can('stockReminderNumber')" key="15">确认库存短信提醒次数</a-menu-item>

        <a-menu-item v-if="can('giftActivity')" key="17">买赠活动</a-menu-item>
        <a-menu-item v-if="can('doorPhoto')" key="18">门头照片限制数量</a-menu-item>
        <a-menu-item v-if="can('malfunction')" key="19">救援故障原因</a-menu-item>

        <a-menu-item v-if="can('useragreement')" key="10">用户协议</a-menu-item>
        <a-menu-item v-if="can('privacypolicy')" key="11">隐私政策</a-menu-item>
      </a-menu>
      <div style="height:100%;" :style="{width: `calc(100% - ${device === 'mobile' ? '0px' : '256px'})`}">
        <div style="height:100%;padding: 20px 24px;" v-if="key==='1' && can('splash')">
          <div class="font-bold text-primary">载入页设置</div>
          <a-upload
            class=" m-t-20"
            list-type="picture-card"
            :disabled="upLoading"
            :show-upload-list="false"
            :custom-request="uploadLoading"
          >
            <img v-if="loadingUrl" :src="loadingUrl" alt="loadingUrl" style="min-width: 280px;height: auto;" />
            <div v-else>
              <a-icon :type="upLoading ? 'loading' : 'cloud-upload'" class="text-gray" :width="24" :height="24" />
              <div class="text-gray font-12">
                上传图片
              </div>
            </div>
          </a-upload>
          <tk-flex middle :gutter="4" class="pt-12">
            <a-icon :type="'exclamation-circle'" class="text-gray" :width="15" :height="15" />
            <div class="font-12 text-gray">建议上传尺寸750x1334px</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(1)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '2' && can('advertise')">
          <div class="font-bold text-primary">广告页设置</div>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">开启状态：</div>
            <a-switch
              :checked="avertiseSwitch"
              @change="handleSwitchChange"
            />
          </tk-flex>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">显示时长：</div>
            <a-input-number
              class="setting-time-input"
              :min="3"
              :max="10"
              :value="avertiseTime"
              @change="handleTimeChange"
            />
            <div class="font-14 text-black">秒</div>
          </tk-flex>
          <a-upload
            class=" m-t-20"
            list-type="picture-card"
            :disabled="upLoading"
            :show-upload-list="false"
            :custom-request="uploadLoading"
          >
            <img v-if="avertiseUrl" :src="avertiseUrl" alt="avertiseUrl" style="min-width: 280px;height: auto;" />
            <div v-else>
              <a-icon :type="upLoading ? 'loading' : 'cloud-upload'" class="text-gray" :width="24" :height="24" />
              <div class="text-gray font-12">
                上传图片
              </div>
            </div>
          </a-upload>
          <tk-flex middle :gutter="4" class="pt-12">
            <a-icon :type="'exclamation-circle'" class="text-gray" :width="15" :height="15" />
            <div class="font-12 text-gray">建议上传尺寸750x1334px</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(2)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '3' && can('storelevel')">
          <ak-model-card model="storeLevel" title="门店等级" :perPage="20" tableSize="small" />
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '4' && can('storestar')">
          <ak-model-card model="storeStarRating" title="门店星级" :perPage="20" tableSize="small" />
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '5' && can('servicefee')">
          <div class="font-bold text-primary">上门服务费</div>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">收取费用：</div>
            <a-input-number
              class="setting-time-input"
              :min="0"
              :max="1000"
              :parser="value => parser(value)"
              v-model="visitCost"
            />
            <div class="font-14 text-black">元</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(5)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '6' && can('nearbystore')">
          <div class="font-bold text-primary">附近门店</div>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">用户可查看附近门店的距离：</div>
            <a-input-number
              class="setting-time-input"
              :min="0"
              :max="10000"
              :parser="value => parserScope(value)"
              v-model="storeScope"
            />
            <div class="font-14 text-black">km</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(6)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key==='7' && can('storebg')">
          <div class="font-bold text-primary">店铺背景图</div>
          <a-upload
            class=" m-t-20"
            list-type="picture-card"
            :disabled="upLoading"
            :show-upload-list="false"
            :custom-request="uploadLoading"
          >
            <img v-if="storeUrl" :src="storeUrl" alt="loadingUrl" style="min-width: 280px;aspect-ratio: 4/3;" />
            <div v-else>
              <a-icon :type="upLoading ? 'loading' : 'cloud-upload'" class="text-gray" :width="24" :height="24" />
              <div class="text-gray font-12">
                上传图片
              </div>
            </div>
          </a-upload>
          <tk-flex middle :gutter="4" class="pt-12">
            <a-icon :type="'exclamation-circle'" class="text-gray" :width="15" :height="15" />
            <div class="font-12 text-gray">建议上传尺寸750x422px</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(7)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key==='8' && can('setpoints')">
          <div class="font-bold text-primary m-b-20">设置积分</div>
          <ak-inputs v-model="points" ref="points" :options="pointsOptions" />
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(8)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key==='9' && can('pointsrules')">
          <ak-inputs v-model="pointsRule" ref="input" :options="pointsRuleOptions" />
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(9)"
          >保存</a-button>
        </div>
        <div style="background:#ffffff;height:100%;padding: 20px 24px;" v-if="key==='10' && can('useragreement')">
          <ak-inputs v-model="agreementData" ref="input1" :options="agreementOptions" />
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(10)"
          >保存</a-button>
        </div>
        <div style="background:#ffffff;height:100%;padding: 20px 24px;" v-if="key==='11' && can('privacypolicy')">
          <ak-inputs v-model="privacyData" ref="input2" :options="privacyOptions" />
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(11)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '12' && can('limitnumber')">
          <div class="font-bold text-primary">限制购买次数</div>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">限制次数：</div>
            <a-input-number
              class="setting-time-input"
              :min="0"
              :max="1000"
              :parser="value => parserInteger(value)"
              v-model="purchaseNumber"
            />
            <div class="font-14 text-black">次/月</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(12)"
          >保存</a-button>
        </div>
        <!-- <div style="height:100%;padding: 20px 24px;" v-if="key === '13' && can('reminderdays')">
          <div class="font-bold text-primary">铺货库存提醒天数</div>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">门店铺户库存设置</div>
            <a-input-number
              class="setting-time-input"
              :min="0"
              :max="1000"
              :parser="value => parserInteger(value)"
              v-model="inventoryReminderDay"
            />
            <div class="font-14 text-black">天后，如果铺货的库存型号未有销售记录，则会给代理商发送提醒消息。</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(13)"
          >保存</a-button>
        </div> -->
        <div style="height:100%;padding: 20px 24px;" v-if="key === '14' && can('cyclingevent')">
          <div class="font-bold text-primary">骑行活动示例图片</div>
          <ak-inputs
            :options="cyclingImageOptions"
            v-model="cyclingImageData"
            ref="cyclingImageInput"
          />
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(14)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '15' && can('stockReminderNumber')">
          <div class="font-bold text-primary">设置未确认库存短信提醒次数</div>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">短信提醒次数：</div>
            <a-input-number
              class="setting-time-input"
              :min="0"
              :max="1000"
              :parser="value => parserInteger(value)"
              v-model="stockReminderNumber"
            />
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(15)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '16' && can('stackheadImage')">
          <div class="font-bold text-primary">堆头活动示例图片</div>
          <ak-type-input v-model="stackheadImage" :field="stackheadImageOption" />
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(16)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '17' && can('giftActivity')">
          <div class="font-bold text-primary">买赠活动</div>
          <ak-inputs v-model="giftActivity" :options="giftActivityOption" ref="giftActivity"/>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(17)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '18' && can('doorPhoto')">
          <div class="font-bold text-primary">门头照片限制数量</div>
          <tk-flex middle class="m-t-20" :gutter="6">
            <div class="font-14 text-black">限制数量：</div>
            <a-input-number
              class="setting-time-input"
              :min="1"
              :max="5"
              :parser="value => parserInteger(value)"
              v-model="doorPhoto"
            />
            <div class="font-14 text-black">张</div>
          </tk-flex>
          <a-button
            type="primary"
            style="margin-top: 40px;"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="handleSave(18)"
          >保存</a-button>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '19' && can('malfunction')">
          <ak-model-card model="malfunction" title="救援故障原因" :perPage="20" tableSize="small" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      lang: localStorage.lang,
      upLoading: false,
      confirmLoading: false,
      settingList: ['splash', 'advertise', 'storelevel', 'storestar', 'servicefee', 'nearbystore',
        'storebg', 'setpoints', 'pointsrules', 'useragreement', 'privacypolicy', 'limitnumber',
        'reminderdays', 'cyclingevent', 'stockReminderNumber', 'stackheadImage', 'giftActivity'],
      agreementOptions: [
        {
          name: 'userAgreement',
          note: '用户协议',
          type: 'Html',
          validators: [
            (val) => val ? null : '用户协议不能为空'
          ]
        }
      ],
      agreementData: { userAgreement: '' },
      privacyOptions: [
        {
          name: 'privacyPolicy',
          note: '隐私协议',
          type: 'Html',
          validators: [
            (val) => val ? null : '隐私协议不能为空'
          ]
        }
      ],
      privacyData: { privacyPolicy: '' },
      pointsRule: { pointsRule: '' },
      pointsRuleOptions: [
        {
          name: 'pointsRule',
          note: '积分规则',
          type: 'Html',
          validators: [
            (val) => val ? null : '积分规则不能为空'
          ]
        }
      ],
      points: {
        showCheckIn: false,
        firstDay: '',
        secondDay: '',
        thirdDay: '',
        fourthDay: '',
        fifthDay: '',
        sixthDay: '',
        seventhDay: ''
      },
      pointsOptions: [
        {
          name: 'showCheckIn',
          note: '是否显示签到活动',
          type: 'Boolean',
          span: 24
        },
        {
          name: 'firstDay',
          note: '连续一天',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '积分不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '积分必须为正整数'
            }
          ],
          span: 12
        },
        {
          name: 'secondDay',
          note: '连续二天',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '积分不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '积分必须为正整数'
            }
          ],
          span: 12
        },
        {
          name: 'thirdDay',
          note: '连续三天',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '积分不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '积分必须为正整数'
            }
          ],
          span: 12
        },
        {
          name: 'fourthDay',
          note: '连续四天',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '积分不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '积分必须为正整数'
            }
          ],
          span: 12
        },
        {
          name: 'fifthDay',
          note: '连续五天',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '积分不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '积分必须为正整数'
            }
          ],
          span: 12
        },
        {
          name: 'sixthDay',
          note: '连续六天',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '积分不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '积分必须为正整数'
            }
          ],
          span: 12
        },
        {
          name: 'seventhDay',
          note: '连续七天',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '积分不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '积分必须为正整数'
            }
          ],
          span: 12
        }
      ],
      cyclingImageOptions: [
        {
          // 电池装车图片
          name: 'batteryLoading',
          note: '电池装车图片',
          type: 'Image',
          tooltip: '建议上传比例为160*160px',
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '电池装车图片不可为空'
          ]
        },
        {
          // 骑行里程照片
          name: 'mileage',
          note: '骑行里程照片',
          type: 'Image',
          tooltip: '建议上传比例为160*160px',
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '骑行里程照片不可为空'
          ]
        },
        {
          // 行驶过程图片
          name: 'driving',
          note: '行驶过程图片',
          type: 'Image',
          tooltip: '建议上传比例为160*160px',
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '行驶过程图片不可为空'
          ]
        }
      ],
      cyclingImageData: {
        batteryLoading: '',
        mileage: '',
        driving: ''
      },
      stackheadImageOption: {
        // 示例图片
        name: 'stackheadImage',
        note: '示例图片',
        type: 'Image',
        tooltip: '建议上传比例为160*160px',
        validators: [ // 表单验证，与model中的validators用法一致
          (val) => val ? null : '示例图片不可为空'
        ]
      },
      stackheadImage: '',
      loadingUrl: '',
      avertiseUrl: '',
      avertiseSwitch: false,
      avertiseTime: 3,
      visitCost: 0, // 上门服务费
      storeScope: 0, // 距离
      storeUrl: '', // 门店图片
      purchaseNumber: 0, // 购买数量
      key: '1',
      inventoryReminderDay: 0, // 铺货库存提醒天数
      stockReminderNumber: 0, // 未确认库存短信提醒数量
      giftActivity: {
        isOpen: false,
        giftImage: ''
      },
      giftActivityOption: [
        {
          name: 'isOpen',
          note: '是否开启',
          type: 'Boolean'
        },
        {
          // 图片
          name: 'giftImage',
          note: '买赠图片',
          type: 'Image',
          tooltip: '建议上传比例为1035*240px',
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '买赠图片不可为空'
          ]
        }
      ],
      doorPhoto: 6,
      malfunction: ''
    }
  },
  computed: {
    _key () {
      return [((this.settingList.findIndex(s => this.can(s))) + 1).toString()]
    }
  },
  mounted () {
    this.key = ((this.settingList.findIndex(s => this.can(s))) + 1).toString()
    this.init()
  },
  methods: {
    // 初始化
    async init () {
      let { data: res } = await this.$tkParse.get('/settings')
      this.loadingUrl = res.loadingUrl || ''
      this.avertiseUrl = res.setAvertise ? res.setAvertise.avertiseUrl : ''
      this.avertiseSwitch = res.setAvertise ? res.setAvertise.avertiseSwitch : false
      this.avertiseTime = res.setAvertise ? res.setAvertise.avertiseTime : 3
      this.agreementData.userAgreement = res.userAgreement || ''
      this.privacyData.privacyPolicy = res.privacyPolicy || ''
      this.visitCost = res.visitCost || 0
      this.purchaseNumber = res.purchaseNumber || 0
      this.storeScope = res.storeScope || 0
      this.storeUrl = res.storeUrl || ''
      this.pointsRule.pointsRule = res.pointsRule || ''
      this.points = res.points || {
        showCheckIn: false,
        firstDay: '',
        secondDay: '',
        thirdDay: '',
        fourthDay: '',
        fifthDay: '',
        sixthDay: '',
        seventhDay: ''
      }
      this.points.showCheckIn = res.points ? res.points.showCheckIn : false
      this.inventoryReminderDay = res.inventoryReminderDay || 0
      this.cyclingImageData = res.cyclingImage || {
        batteryLoading: '',
        mileage: '',
        driving: ''
      }
      this.stockReminderNumber = res.stockReminderNumber || 0
      this.stackheadImage = res.stackheadImage || ''
      this.giftActivity = res.giftActivity || {
        isOpen: false,
        giftImage: ''
      }
      this.doorPhoto = res.doorPhoto || 5
    },
    // 金额
    parser (value) {
      // eslint-disable-next-line no-useless-escape
      return value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    // 距离
    parserScope (value) {
      // 一位小数 不能为0
      // eslint-disable-next-line no-useless-escape
      return value.replace(/^(0+)|[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    // 次数
    parserInteger (value) {
      // 正整数
      // eslint-disable-next-line no-useless-escape
      return value.replace(/[^\d]/g, '')
    },
    // 点击切换
    handleClick (e) {
      this.key = e.key
      this.init()
    },
    // 上传loading
    uploadLoading (options) {
      this.upLoading = true
      const reader = new FileReader()
      reader.onload = async () => {
        let res = await this.$tkParse.post('/files', reader.result).catch(e => {
          this.upLoading = false
          throw this.$notification['error']({
            message: '网络错误',
            description: '网络错误,请重试'
          })
        })
        if (this.key === '1') {
          this.loadingUrl = res.data.url
        } else if (this.key === '2') {
          this.avertiseUrl = res.data.url
        } else {
          this.storeUrl = res.data.url
        }
        this.upLoading = false
      }
      reader.readAsArrayBuffer(options.file)
    },
    // 显示时长
    handleTimeChange (val) {
      this.avertiseTime = val
    },
    // 广告页开启状态
    handleSwitchChange (val) {
      this.avertiseSwitch = val
    },
    // 保存
    async handleSave (key) {
      try {
        this.confirmLoading = true
        switch (key) {
          case 1:
            if (!this.loadingUrl) {
              this.confirmLoading = false
              return this.$notification['error']({
                message: '未发现有效图片地址',
                description: '请上传载入页图片'
              })
            }
            await this.$tkParse.put('/settings', {
              loadingUrl: this.loadingUrl
            })
            break
          case 2:
            if (!this.avertiseUrl) {
              this.confirmLoading = false
              return this.$notification['error']({
                message: '未发现有效图片地址',
                description: '请上传广告页图片'
              })
            }
            await this.$tkParse.put('/settings', {
              setAvertise: {
                avertiseUrl: this.avertiseUrl,
                avertiseSwitch: this.avertiseSwitch,
                avertiseTime: this.avertiseTime
              }
            })
            break
          case 5:
            await this.$tkParse.put('/settings', {
              visitCost: this.visitCost
            })
            break
          case 6:
            await this.$tkParse.put('/settings', {
              storeScope: this.storeScope
            })
            break
          case 7:
            if (!this.storeUrl) {
              this.confirmLoading = false
              return this.$notification['error']({
                message: '未发现有效图片地址',
                description: '请上传店铺背景图片'
              })
            }
            await this.$tkParse.put('/settings', {
              storeUrl: this.storeUrl
            })
            break
          case 8:
            let pointsErrors = await this.$refs.points.validate()
            if (Object.keys(pointsErrors).length) {
              this.confirmLoading = false
              return
            }
            await this.$tkParse.put('/settings', {
              points: this.points
            })
            break
          case 9:
            let errors = await this.$refs.input.validate()
            if (Object.keys(errors).length) {
              this.confirmLoading = false
              return
            }
            await this.$tkParse.put('/settings', {
              pointsRule: this.pointsRule.pointsRule
            })
            break
          case 10:
            let errors1 = await this.$refs.input1.validate()
            if (Object.keys(errors1).length) {
              this.confirmLoading = false
              return
            }
            await this.$tkParse.put('/settings', {
              userAgreement: this.agreementData.userAgreement
            })
            break
          case 11:
            let errors2 = await this.$refs.input2.validate()
            if (Object.keys(errors2).length) {
              this.confirmLoading = false
              return
            }
            await this.$tkParse.put('/settings', {
              privacyPolicy: this.privacyData.privacyPolicy
            })
            break
          case 12:
            await this.$tkParse.put('/settings', {
              purchaseNumber: this.purchaseNumber
            })
            break
          case 13:
            await this.$tkParse.put('/settings', {
              inventoryReminderDay: this.inventoryReminderDay
            })
            break
          case 14:
            let cyclingImageInputError = await this.$refs.cyclingImageInput.validate()
            if (Object.keys(cyclingImageInputError).length) {
              this.confirmLoading = false
              return
            }
            await this.$tkParse.put('/settings', {
              cyclingImage: this.cyclingImageData
            })
            break
          case 15:
            await this.$tkParse.put('/settings', {
              stockReminderNumber: this.stockReminderNumber
            })
            break
          case 16:
            if (!this.stackheadImage) {
              this.confirmLoading = false
              return this.$notification['error']({
                message: '未发现有效图片地址',
                description: '请上传堆头活动示例图片'
              })
            }
            await this.$tkParse.put('/settings', {
              stackheadImage: this.stackheadImage
            })
            break
          case 17:
            let giftActivityError = await this.$refs.giftActivity.validate()
            if (Object.keys(giftActivityError).length) {
              this.confirmLoading = false
              return
            }
            await this.$tkParse.put('/settings', {
              giftActivity: this.giftActivity
            })
            break
          case 18:
            await this.$tkParse.put('/settings', {
              doorPhoto: this.doorPhoto
            })
            break
        }
        this.confirmLoading = false
        this.$notification['success']({
          message: '设置成功',
          description: '保存成功'
        })
      } catch (e) {
        this.confirmLoading = false
        this.$notification['error']({
          message: '设置失败',
          description: '网络错误,请重试'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">

.page-header {
  background: #fff;
  padding: 16px 32px 0;
  border-bottom: 1px solid #e8e8e8;
  margin: -24px -24px 24px -24px;
  .breadcrumb {
    margin-bottom: 16px;
  }
  .detail {
    display: flex;
    /*margin-bottom: 16px;*/
    .avatar {
      flex: 0 1 72px;
      margin: 0 24px 8px 0;
      & > span {
        border-radius: 72px;
        display: block;
        width: 72px;
        height: 72px;
      }
    }
    .main {
      width: 100%;
      flex: 0 1 auto;
      .row {
        display: flex;
        width: 100%;
        .avatar {
          margin-bottom: 16px;
        }
      }
      .title {
        font-size: 20px;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 16px;
        flex: auto;
      }
      .logo {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        margin-right: 16px;
      }
      .content,
      .headerContent {
        flex: auto;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 32px;
          }
        }
      }
      .extra {
        flex: 0 1 auto;
        margin-left: 88px;
        min-width: 242px;
        text-align: right;
      }
      .action {
        margin-left: 56px;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: right;
        &:empty {
          display: none;
        }
      }
    }
  }
}
.mobile .page-header {
  .main {
    .row {
      flex-wrap: wrap;
      .avatar {
        flex: 0 1 25%;
        margin: 0 2% 8px 0;
      }
      .content,
      .headerContent {
        flex: 0 1 70%;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 10px;
          }
        }
      }
      .extra {
        flex: 1 1 auto;
        margin-left: 0;
        min-width: 0;
        text-align: right;
      }
      .action {
        margin-left: unset;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: left;
        margin-bottom: 12px;
        &:empty {
          display: none;
        }
      }
    }
  }
}
.container {
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: stretch;
  .text-primary {
    color: #202224;
  }
  .text-black {
    color: #363B45;
  }
  .text-gray {
    color: #808690;
  }
  .ant-btn {
    width: 54px !important;
    height: 32px !important;
    padding: 0 !important;
  }
  .setting-time-input {
    width: 75px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #DBDDE1;
    border-radius: 6px;
  }
  .ant-upload {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
